// import { Tooltip } from "antd";
// import React from "react";
// import GaugeChart from "react-gauge-chart";
// import { QuestionCircleOutlined } from "@ant-design/icons";

// const GaugeCardConsumer = ({ label, value, min = 0, max = 1, unit = "", description = "Excellent" }) => {
//   // Convert value to 0-1 for the gauge
//   const percent = (value - min) / (max - min);

//   return (
//     <div
//       className="iconFont cardViewMain"
//       style={{
//         borderRadius: 20,
//         padding: 24,
//         width: 228,
//         margin: 16,
//         display: "inline-block",
//         verticalAlign: "top",
//       }}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <span style={{ color: "#999" }}>{label}</span>

//         <Tooltip title={`What is ${label}?`}>
//           <QuestionCircleOutlined />
//         </Tooltip>
//       </div>
//       <GaugeChart
//         id={`gauge-chart-${label}`}
//         nrOfLevels={3}
//         colors={["#9FC7FF", "#00E3C4", "#3166D8"]}
//         arcWidth={0.15}
//         percent={percent}
//         arcPadding={0.06}
//         textColor="#11305C"
//         needleColor="#00E3C4"
//         hideText={true}
//       />
//       <div
//         style={{
//           position: "relative",
//           top: "-15px",
//           textAlign: "center",
//           fontSize: "1em",
//         }}
//         className="colorWhite"
//       >
//         {value}
//         {unit}
//       </div>
//       <div
//         style={{
//           position: "relative",
//           top: "-10px",
//           textAlign: "center",
//         }}
//         className="colorWhite"
//       >
//         {description}
//       </div>
//     </div>
//   );
// };

// export default GaugeCardConsumer;



import React from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const GaugeCardConsumer = ({
  label,
  value,
  max = 100,
  unit = "",
  description,
  color,
}) => {
  const size = 160;
  const strokeWidth = 8;
  const radius = 60;
  const center = size / 2;
  const circumference = 2 * Math.PI * radius;

  const normalizedValue = Math.min(Math.max(value, 0), max);
  const percent = normalizedValue / max;
  const dashOffset = circumference - percent * circumference;

  const getStatusColor = (desc) => {
    switch (desc) {
      case "Excellent":
         return "#41746E";        
      case "Moderate":
        return "#EAB308";       
      case "Low":
        return "#41746E";
      default:
        return color || "#2dd4bf";
    }
  };

  const activeColor = color || getStatusColor(description);

  return (
    <div className="gauge-card">
      <div className="gauge-wrapper">
        {/* <div className="icon-wrapper">
          <Tooltip title={`Details about ${label}`}>
            <QuestionCircleOutlined className="info-icon" />
          </Tooltip>
        </div> */}

        <svg
          viewBox="0 0 160 160"
          className="gauge-svg"
        >
          <circle
            cx={center}
            cy={center}
            r={radius}
            className="gauge-track"
            strokeWidth={strokeWidth}
          />

          <circle
            cx={center}
            cy={center}
            r={radius}
            className="gauge-progress"
            stroke={activeColor}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${center} ${center})`}
          />
        </svg>

        <div className="gauge-value">
          {value}
          {unit && <span className="gauge-unit">{unit}</span>}
        </div>
      </div>

      <div className="text-container">
        <div className="label">{label}</div>
        <div className="status" style={{ color: activeColor }}>
          {description}
        </div>
      </div>
    </div>
  );
};

export default GaugeCardConsumer;



